import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['processingSpinner'];

  connect() {
    if (this.hasProcessingSpinnerTarget) {
      const searchController =
        this.application.getControllerForElementAndIdentifier(
          this.element.closest('[data-controller*="search"]'),
          'search',
        );

      if (searchController)
        // If there are still processing results, update again in 5 seconds
        setTimeout(() => searchController.update(), 5000);
    }
  }
}
